import { Sparkles } from 'lucide-react'
import type { NavEntry } from '@/app/nav-registry'

/** Nav entries only — imported by the eager shell bundle; keep free of pages/api (H-10). */

export const aiNav: NavEntry = {
  label: 'AI',
  icon: Sparkles,
  path: '/ai',
  permission: 'ai:use',
  // Without this the entry renders whenever companySettings.aiEnabled is true even
  // if the `ai` module is off, and the route then dead-ends on the shell's module
  // gate. Every other nav entry carries its module key (audit H-04).
  moduleKey: 'ai',
  order: 8,
}
